import { Attribute, component, property } from '../../../concepts/objects';
import { memoUsing } from '../../../concepts/objects/MemoUsing';
import { Point } from '../../../platform/geom/Point';
import { Physical } from '../../canvas/entities/Physical';
import { ContainerLike } from '../../canvas/entities/PhysicalMechanics';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Resizable } from '../../canvas/entities/Resizable';
import { Snappable } from '../../canvas/entities/Snappable';
import { GraffitiTarget } from '../../canvas/visualization/Graffiti';
import { graphicPropertyLayout } from './GraphicPropertyLayout';
import { GraphicTexture } from './GraphicTexture';

const graphicDef = {
    name: 'Graphic',
    implements: [
        Physical,
        Resizable,
        ContainerLike,
        GraffitiTarget,
        Snappable,
    ],
    propertyLayout: graphicPropertyLayout,
};

export type GraphicData = {
    url: string,
    img: HTMLImageElement,
};

export const LocalUrlAttr = new Attribute<string, Graphic>('localUrl');
export const GraphicDataAttr = new Attribute<GraphicData, Graphic>('graphicData');

@component(graphicDef)
export class Graphic extends RectangularPhysical implements ContainerLike, Snappable {

    @property({ type: 'string' })
    public url!: string;

    @property({ type: 'boolean', default: true })
    public container!: boolean;

    @memoUsing('width', 'height', GraphicDataAttr)
    public get texture() {
        return GraphicTexture.for(this);
    }

    public get boundary() {
        return !this.container;
    }

    public get shouldSnap() {
        return true;
    }

    public test(mpt: Point): boolean {
        if (!super.test(mpt)) return false;

        const lpt = this.toRelative(mpt);

        const { texture } = this;
        if (!texture) return true;

        const pixel = texture.getPixel(lpt);
        return pixel.alpha > 0;
    }
}
